/**
 * Pricing page interactions:
 * - monthly/yearly tabs on plan sections ([data-pricing-tabs])
 * - add-ons & support service accordions (.pas)
 * - legacy add-ons list (.addon-item)
 * - terms & conditions accordion (.pricing-terms)
 */
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-pricing-tabs]').forEach(function (section) {
        var tabs = section.querySelectorAll('.pricing-tab');
        var periodEls = section.querySelectorAll('.pricing-card__price, .pricing-card__save');
        tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                var period = this.dataset.tab;
                tabs.forEach(function (t) {
                    t.classList.remove('active');
                    t.setAttribute('aria-selected', 'false');
                });
                this.classList.add('active');
                this.setAttribute('aria-selected', 'true');
                periodEls.forEach(function (el) {
                    el.classList.toggle('hidden', el.dataset.period !== period);
                });
            });
        });
    });

    document.querySelectorAll('.pas .pas-service__header').forEach(function (header) {
        header.addEventListener('click', function () {
            var item = this.closest('.pas-service');
            var isOpen = item.classList.contains('is-open');
            item.classList.toggle('is-open', !isOpen);
            this.setAttribute('aria-expanded', String(!isOpen));
        });
    });

    document.querySelectorAll('.addon-item__toggle').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var item = this.closest('.addon-item');
            var isOpen = item.classList.contains('addon-item--open');
            item.classList.toggle('addon-item--open', !isOpen);
            this.setAttribute('aria-expanded', String(!isOpen));
            item.querySelector('.addon-item__body').style.display = isOpen ? 'none' : 'block';
        });
    });

    document.querySelectorAll('.pricing-terms').forEach(function (section) {
        section.querySelectorAll('.pt-item__toggle').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var item = this.closest('.pt-item');
                var isOpen = item.classList.contains('pt-item--open');

                section.querySelectorAll('.pt-item--open').forEach(function (el) {
                    if (el !== item) {
                        el.classList.remove('pt-item--open');
                        el.querySelector('.pt-item__toggle').setAttribute('aria-expanded', 'false');
                    }
                });

                item.classList.toggle('pt-item--open', !isOpen);
                this.setAttribute('aria-expanded', String(!isOpen));
            });
        });
    });
});
